import { render, staticRenderFns } from "./card_profile_patient.vue?vue&type=template&id=4add81d6&scoped=true"
import script from "./card_profile_patient.vue?vue&type=script&lang=js"
export * from "./card_profile_patient.vue?vue&type=script&lang=js"
import style0 from "./card_profile_patient.vue?vue&type=style&index=0&id=4add81d6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4add81d6",
  null
  
)

export default component.exports